import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';
import { CardCustomerComponent } from './card-customer/card-customer.component';
import { MediaComponent } from './media/media.component';
import { FormsModule } from '@angular/forms';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import {AutoCompleteModule} from 'primeng/autocomplete'
import { ApiService } from '../services/api.service';

@NgModule({
  declarations: [
    FooterComponent,
    MediaComponent,
    HeaderComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    AutocompleteLibModule,
    AutoCompleteModule,

  ],
  providers:[ApiService],
  exports:[
    FooterComponent,
    MediaComponent,
    HeaderComponent,
  ]
})
export class ShareModule { }
